import { gql } from '@apollo/client'

export const HOLE_IN_ONE_BY_CLAIM_TOKEN = gql`
  query HoleInOneByClaimToken($claimToken: String!) {
    holeInOneByClaimToken(claimToken: $claimToken) {
      id
      maskedEmail
      golferName
      courseName
      occurredAt
      holeNumber
      holePar
      yardage
      legalAgreementsAcceptedAt
    }
  }
`

export const REQUEST_GOLFER_OTP = gql`
  mutation RequestGolferOtp($input: RequestGolferOtpInput!) {
    requestGolferOtp(input: $input) {
      success
      message
    }
  }
`

export const CLAIM_HOLE_IN_ONE = gql`
  mutation ClaimHoleInOne($input: ClaimHoleInOneInput!) {
    claimHoleInOne(input: $input) {
      token
      holeInOne {
        id
        golferName
        status
      }
      errors
    }
  }
`
